const $$splitComponentImporter = () => import('/home/runner/work/graph-it/graph-it/apps/graphit/src/routes/_authed/cartographies/$id/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { ApiCaller } from '@graphit/callers';
import { LoadingSpinner } from '~/components/LoadingSpinner';
import { cartographyQueryOptions } from '~/queries/cartography';
import { meQueryOptions } from '~/queries/me';
export const Route = createFileRoute('/_authed/cartographies/$id')({
  loader: async ({
    context,
    params
  }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions);
    if (me.lastViewedCartographyId !== params.id) {
      context.queryClient.setQueryData(meQueryOptions.queryKey, {
        ...me,
        lastViewedCartographyId: params.id
      });
      void ApiCaller.setLastViewedCartography(params.id).catch(() => {});
    }
    return context.queryClient.ensureQueryData(cartographyQueryOptions(params.id));
  },
  pendingComponent: GraphAreaSpinner,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
function GraphAreaSpinner() {
  return <div className="w-full h-full flex items-center justify-center">
			<LoadingSpinner size="large" />
		</div>;
}